import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState = {
  templateTypesListReset: false,
};

export const templateSlice = createSlice({
  name: "template",
  initialState,
  reducers: {
    setTemplateTypesListReset: (state) => {
      state.templateTypesListReset = !state.templateTypesListReset;
    },
  },
});

export const templateAction = templateSlice.actions;
export const templateReducer = templateSlice.reducer;
